import { populateZmanimTable } from './shared/zmanim-shabbos.js';

export function renderShabbosScreen(bgImageUrl, zmanimOptions) {
    $('body').addClass('shabbos-mode-active');
    $('body').css({ 'background-image': 'url(' + bgImageUrl + ')' });

    const zmanimTable = document.getElementById('zmanim_table');
    if (zmanimTable && zmanimOptions) {
        try {
            populateZmanimTable(zmanimTable, zmanimOptions);
        } catch (error) {
            console.error(error);
        }
    }
}
